module.exports = __webpack_public_path__ + "img/オンライン販売チームを活用し、香港市場向けにOTC医薬品と健康食品をEC販売しております。 OEMやODMで市場の拡大と販売網.274c043c.png";